import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { useContext, useEffect, useState } from 'react'
import { Form, Input } from 'antd'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import api from '../../api/index.api'
import { ButtonCommon } from '../../common'
import { AdminContext } from '../../context/admin.context'
import { MESSAGE } from '../../utils/constant'
import {
	showMessageError,
	showMessageSuccess,
} from '../../utils/function.utils'
import './Login.scss'

const Login = ({ history }) => {
	const [form] = Form.useForm()
	const [isLoading, setIsLoading] = useState(false)
	const [adminContext, setAdminContext] = useContext(AdminContext)
	useEffect(() => {
		if (adminContext) history.push('/')
	}, [history, adminContext])

	const onSubmit = async () => {
		setIsLoading(true)
		try {
			const values = await form.validateFields()
			await api.authentication.logIn(values)
			const profile = await api.userApi.getProfile()
			if (!profile?.roleMap?.admin) {
				throw new Error('Tài khoản không có quyền quản trị.')
			}
			showMessageSuccess()
			setAdminContext(profile)
			history.push('/')
		} catch (err) {
			if (err?.errorFields?.length) {
				// Ant Design form validation — field messages are shown inline
				setIsLoading(false)
				return
			}
			const msg =
				err instanceof Error
					? err.message
					: typeof err === 'string'
						? err
						: MESSAGE.ERROR
			console.error('Login failed:', err)
			showMessageError(msg)
			setIsLoading(false)
		}
	}

	return (
		<section className="login-wrap">
			<div className="card-container">
				<div className="login-logo-wrap">
					<h1 className="login-brand">WORDSMINE</h1>
				</div>
				<Form form={form} name="dynamic_rule" className="content-form">
					<Form.Item
						className="form-item-custom"
						name="authEmail"
						type="string"
						rules={[
							{ transform: value => (value ? value.trim() : '') },
							{
								required: true,
								message: 'Tài khoản không được bỏ trống!',
							},
						]}
					>
						<Input
							placeholder="Tài khoản"
							type="string"
							autoFocus
							prefix={<UserOutlined />}
						/>
					</Form.Item>

					<Form.Item
						className="form-item-custom"
						name="password"
						type="password"
						rules={[
							{ transform: value => (value ? value.trim() : '') },
							{
								required: true,
								message: 'Mật khẩu không được bỏ trống',
							},
						]}
					>
						<Input.Password
							placeholder="Mật khẩu"
							type="password"
							prefix={<LockOutlined />}
						/>
					</Form.Item>

					<Form.Item className="form-item-btn">
						<ButtonCommon
							type="primary"
							loading={isLoading}
							onClick={onSubmit}
						>
							Đăng nhập
						</ButtonCommon>
					</Form.Item>
				</Form>
			</div>
		</section>
	)
}

Login.propTypes = {
	history: PropTypes.object,
}

export const LoginPage = withRouter(Login)
